export const withdrawalSteps = {
  withdrawalStepsAccount: "账户",
  withdrawalStepsAmount: "金额",
  withdrawalStepsWidthdraw: "提现",
  withdrawalStepsError: "提现失败",
  withdrawalStepsErrorDesc_1: "您需要至少播放30%的存款金额才能提现。",
  withdrawalStepsErrorDesc_2: "您的提现失败了, 请检查您的数据或联系客服。",
  withdrawalStepsErrorDesc_3: "您的帐户尚未验证。验证邮件已发送到您的邮箱。",
  withdrawalStepsErrorDesc_4: "提现金额不在允许的范围内。",
  withdrawalStepsSuccess: "提现成功",
  withdrawalStepsSuccessMessage: "您的提现已经成功处理。",
  emailVerificationSentTitle: "电子邮件验证",
  emailVerificationSentMessage: "验证邮件已发送到您的邮箱。请检查您的收件箱。",
  emailVerificationErrorTitle: "发送验证失败",
  emailVerificationErrorMessage: "无法发送验证邮件。请重试或联系支持。",
  withdrawalStepsNext: "下一步",
  withdrawalStepsBack: "返回",
  withdrawalStepsConfirm: "确认",
  withdrawalStepsCancel: "取消",

  // Content step 1,
  withdrawalStepsDailyWithdrawal: "日提现",
  withdrawalStepsWeeklyWithdrawal: "周提现",
  withdrawalStepsWithdrawn: "提现",
  withdrawalStepsDailyRemaining: "日剩余",
  withdrawalStepsWeeklyRemaining: "周剩余",
  withdrawalStepsSelectAccount: "选择您的手机支付账户",
  withdrawalStepsSelectAccountDesc: "请选个你的手机支付账户，就可以提款。",
  withdrawalStepsSelectAccountDesc2: "如果还没有设置手机支付账户，请点击 ",
  withdrawalStepsSelectAccountlink: "这里",
  withdrawalStepsSelectTitle: "银行",
  withdrawalStepsSelectAccount_select: "选择一个账户",

  // step 1 modal
  withdrawalStepsModalLimitReachedTitle: "限额到达",
  withdrawalDayModalLimitReachedMessage: "已达到日提现限额。请明天再试。",
  withdrawalWeekModalLimitReachedMessage: "已达到周提现限额。请下周再试。",
  withdrawalStepsModalLimitReachedButton: "确认",

  // Content step 2,
  withdrawalSteps_2_Amount: "输入提现金额",
  withdrawalSteps_2_AmountInput: "输入金额",
  widthdrawalSteps_2_Error: "提现金额错误",
  withdrawalSteps_2_AmountError: "请输入正确的金额",
  widthdrawalSteps_2_Error2: "账户余额不足",
  widthdrawalSteps_2_Error3: "最低金额 200 Bs",
  widthdrawalSteps_2_Error4: "最高金额 8,000 Bs 日",

  // Content step 3,
  withdrawalSteps_3_Confirm: "提现确认",
  withdrawalSteps_3_Bank: "银行 ",
  withdrawalSteps_3_PhoneNumber: "电话号码",
  withdrawalSteps_3_Amount: "金额",
  withdrawalSteps_3_YouWillWithdraw: "您将提取",

  // Conditional form translations for withdrawals
  withdrawalExplanationTitle: "需要个人注册",
  withdrawalExplanationMessage:
    "为完成提现，您需要注册个人信息（姓名、身份证号和电话号码）。此信息是安全处理您的提现所必需的。",
  registerAndWithdraw: "注册并提现",

  // BINANCE WITHDRAWAL
  binanceWithdrawalTitle: "币安提现",
  binanceWithdrawalNetwork: "网络",
  binanceWithdrawalMinAmount: "最低金额",
  binanceWithdrawalMaxAmount: "最高金额",
  binanceWithdrawalCommission: "手续费",
  binanceWithdrawalAmountRequired: "金额是必需的。",
  binanceWithdrawalAddress: "钱包地址 (TRC20)",
  binanceWithdrawalAddressModal: "钱包地址",
  binanceWithdrawalAddressPlaceholder: "输入钱包地址 (TRC20)",
  binanceWithdrawalAmount: "提取金额",
  binanceWithdrawalAmountPlaceholder: "输入提取金额",
  binanceWithdrawalConfirmTitle: "确认币安提现",
  binanceWithdrawalInputErrorNumber: "只允许数字和小数点。",
  binanceWithdrawalInputErrorInvalid: "金额无效。",
  binanceWithdrawalInputErrorMin: "最低金额为",
  binanceWithdrawalInputErrorMax: "最高金额为",
  binanceWithdrawalAddressErrorRequired: "钱包地址是必需的。",
  binanceWithdrawalAddressErrorStart: "钱包地址必须以'T'开头。",
  binanceWithdrawalAddressErrorLength: "钱包地址必须为34个字符。",
  binanceWithdrawalSuccessTitle: "提现成功",
  binanceWithdrawalAmountCorrect: "正确的金额。",
  binanceWithdrawalAddressCorrect: "正确的钱包地址。",
  binanceWithdrawalContinueBtn: "继续",
  binanceWithdrawalConfirmBtn: "确认",

  // Withdrawal success/failure modal states
  withdrawalSuccessTitle: "提现请求成功！",
  withdrawalSuccessMessage: "您的提现请求已成功处理。您将很快在您的手机支付账户中收到付款。",
  withdrawalSuccessClose: "关闭",
  withdrawalFailureTitle: "提现失败",
  withdrawalFailureMessage: "我们无法处理您的提现请求。请检查详细信息并重试。",
  withdrawalFailureRetry: "重试",
  withdrawalFailureClose: "关闭",
};
